import moment from 'moment';

export default function (val: string | string | undefined) {
  if (!val) {
    return '';
  }

  return moment(val).format('DD.MM.YYYY HH:mm:SS');
}
